import { Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { EmptyStateComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-requisitions-access-denied-page',
  template: `
    <rt-empty-state
      variant="default"
      [icon]="'assignment-turned-in'"
      [title]="'app.requisitions.access_denied.title' | translate"
      [desc]="'app.requisitions.access_denied.description' | translate"
    />
  `,
  styleUrls: ['./access-denied-page.component.less'],
  imports: [EmptyStateComponent, TranslatePipe],
})
export class AccessDeniedPageComponent {}
